import { addEventListener } from './utils';

const modalHelper = {
  permissions: {} as InitializationProperties,

  closeModalButtonHandler: (event: Event) => {
    if (event.target instanceof Element) {
      window.Sq.Tracking.track(
        {
          action: 'Click Close Modal Button',
        },
        { destinations: ['cdp'] }
      );
    }
  },
  openModalButtonHandler: (event: Event) => {
    const target = event.target as HTMLElement;
    const properties: Record<string, string> = {
      triggerText: target.innerText.trim(),
    };

    if (target instanceof Element) {
      window.Sq.Tracking.track(
        {
          action: 'Click Open Modal Button',
          properties,
        },
        { destinations: ['cdp'] }
      );
    }
  },
  outsideClickHandler: (event: MouseEvent, modalWrapper: HTMLElement, modalHelperCallbackFunction: () => void) => {
    const element = event.target as HTMLElement;
    if (!modalWrapper.contains(element)) {
      modalHelperCallbackFunction();
    }
  },
  attachListeners: () => {
    const openModalButtonElement: HTMLElement = document.getElementsByClassName('trigger')[0] as HTMLElement;
    const closeModalButtonElement: HTMLElement = document.getElementsByClassName('close-button')[0] as HTMLElement;
    if (openModalButtonElement) {
      addEventListener(openModalButtonElement, 'click', modalHelper.openModalButtonHandler);
    }
    if (closeModalButtonElement) {
      addEventListener(closeModalButtonElement, 'click', modalHelper.closeModalButtonHandler);
    }
  },
  initialize: (permissions: InitializationProperties): Promise<void> => {
    modalHelper.permissions = permissions;
    return new Promise((resolve) => {
      modalHelper.attachListeners();
      resolve();
    });
  },
};

export default modalHelper;
